import ET3Div from "../../../../et3-div";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";
import InvestigateButton from "./InvestigateButton";
import SaveButton from "./SaveButton";

const TBWPopUpButtons = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-around"
      alignItems="center"
      withShadow={false}
      width={1000}
      height={100}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <InvestigateButton />
      <SaveButton />
    </ET3Div>
  );
});

export default TBWPopUpButtons;
